export default __webpack_public_path__ + "static/media/presentation.c7da81fb.jpg";